import { render, staticRenderFns } from "./project-issue-type-users.vue?vue&type=template&id=79115ffc"
import script from "./project-issue-type-users.vue?vue&type=script&lang=js"
export * from "./project-issue-type-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports